import {
  onKeyUpEscape,
  defineElement,
  PUB_SUB_EVENTS,
  trapFocus,
  removeTrapFocus,
} from "./gw.js";
import { subscribe, publish } from "./pubsub.js";
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );
  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }
  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });
  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;
  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });
  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });
  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");
      if (mouseClick) return;
      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}
class QuantityInput extends HTMLElement {
  quantityUpdateUnsubscriber;
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", {
      bubbles: true,
    });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }
  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this),
    );
  }
  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }
  onInputChange(event) {
    this.validateQtyRules();
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    if (event.target.name === "plus") {
      if (
        Number.parseInt(this.input.dataset.min) >
          Number.parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
    if (
      this.input.dataset.min === previousValue &&
      event.target.name === "minus"
    ) {
      this.input.value = Number.parseInt(this.input.min);
    }
  }
  validateQtyRules() {
    const value = Number.parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle(
        "disabled",
        Number.parseInt(value) <= Number.parseInt(this.input.min),
      );
    }
    if (this.input.max) {
      const max = Number.parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}
defineElement("quantity-input", QuantityInput);
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};
Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};
Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};
Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options["method"] || "post";
  const params = options["parameters"] || {};
  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);
  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options.hideElement || province_domid,
  );
  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },
  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },
  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },
  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};
class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)",
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }
  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;
    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }
    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }
  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(event, elementToFocus = false) {
    if (event === void 0) return;
    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
    if (event instanceof KeyboardEvent)
      elementToFocus == null
        ? void 0
        : elementToFocus.setAttribute("aria-expanded", false);
  }
  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }
  closeAnimation(detailsElement) {
    let animationStart;
    const handleAnimation = (time) => {
      if (animationStart === void 0) {
        animationStart = time;
      }
      const elapsedTime = time - animationStart;
      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };
    window.requestAnimationFrame(handleAnimation);
  }
}
defineElement("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${Number.parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`,
    );
  };
  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom",
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${Number.parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    );
    this.header.classList.add("menu-open");
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }
}
defineElement("header-drawer", HeaderDrawer);
class VariantSelects extends HTMLElement {
  connectedCallback() {
    this.addEventListener("change", (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);
      const productId = target.dataset.productId;
      const payload = {
        data: {
          event,
          target,
          value: target.value,
          selectedOptionValues: this.selectedOptionValues,
        },
      };
      publish(PUB_SUB_EVENTS.optionValueSelectionChange, payload);
      publish(
        `${PUB_SUB_EVENTS.optionValueSelectionChange}:${productId}`,
        payload,
      );
    });
  }
  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;
    if (tagName === "SELECT" && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute("selected"))
        .removeAttribute("selected");
      target.selectedOptions[0].setAttribute("selected", "selected");
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest(".product-form__input")
        .querySelector("[data-selected-value] > .swatch");
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          swatchValue,
        );
        selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          "unset",
        );
        selectedDropdownSwatchValue.classList.add("swatch--unavailable");
      }
      selectedDropdownSwatchValue.style.setProperty(
        "--swatch-focal-point",
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset",
      );
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = target
        .closest(`.product-form__input`)
        .querySelector("[data-selected-value]");
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }
  getInputForEventTarget(target) {
    return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
  }
  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll("select option[selected], fieldset input:checked"),
    ).map(({ dataset }) => dataset.optionValueId);
  }
}
defineElement("variant-selects", VariantSelects);
class ProductRecommendations extends HTMLElement {
  observer;
  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }
  initializeRecommendations(productId) {
    var _a;
    (_a = this.observer) == null ? void 0 : _a.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      {
        rootMargin: "0px 0px 400px 0px",
      },
    );
    this.observer.observe(this);
  }
  loadRecommendations(productId) {
    fetch(
      `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`,
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");
        if (
          recommendations == null
            ? void 0
            : recommendations.innerHTML.trim().length
        ) {
          this.innerHTML = recommendations.innerHTML;
        }
        if (
          !this.querySelector("slideshow-component") &&
          this.classList.contains("complementary-products")
        ) {
          this.remove();
        }
        if (html.querySelector(".grid__item")) {
          this.classList.add("product-recommendations--loaded");
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
defineElement("product-recommendations", ProductRecommendations);
class VideoToggle extends HTMLElement {
  initialized = false;
  videoContainer;
  videos;
  constructor() {
    super();
    this.button = this.querySelector("button");
    this.onClick = this.toggle.bind(this);
  }
  connectedCallback() {
    this.init();
  }
  disconnectedCallback() {
    this.destroy();
  }
  init() {
    var _a;
    if (this.initialized) return;
    const ariaControls = this.button.getAttribute("aria-controls");
    this.videos = ariaControls
      ? ariaControls.split(" ").map((id) => document.getElementById(id))
      : [
          ...(((_a = this.closest(
            "ambient-media, deferred-media, [data-video-container]",
          )) == null
            ? void 0
            : _a.querySelectorAll("video")) ?? []),
        ];
    if (!this.videos.length) return;
    if (!this.hasAttribute("play-state")) {
      window.addEventListener("load", () => {
        this.playState = this.videos[0].paused ? "paused" : "playing";
      });
    }
    this.button.addEventListener("click", this.onClick);
    this.initialized = true;
  }
  destroy() {
    if (!this.initialized) return;
    this.button.removeEventListener("click", this.onClick);
    this.initialized = false;
  }
  get playState() {
    return this.getAttribute("play-state");
  }
  set playState(value) {
    this.setAttribute("play-state", value);
  }
  play() {
    this.setPlayState(true);
    this.videos.forEach((video) => {
      video.play();
    });
  }
  pause() {
    this.setPlayState(false);
    this.videos.forEach((video) => {
      video.pause();
    });
  }
  setPlayState(value = true) {
    this.playState = value ? "playing" : "paused";
    this.updateAriaLabel();
  }
  updateAriaLabel() {
    this.button.setAttribute(
      "aria-label",
      this.playState === "playing"
        ? window.accessibilityStrings.pauseVideo
        : window.accessibilityStrings.playVideo,
    );
  }
  get isPlaying() {
    return this.videos.some((video) => !video.paused);
  }
  toggle() {
    this.isPlaying ? this.pause() : this.play();
  }
  togglePlayState() {
    this.setPlayState(!this.isPlaying);
  }
}
defineElement("video-toggle", VideoToggle);
class AccountIcon extends HTMLElement {
  constructor() {
    super();
    this.icon = this.querySelector(".icon");
  }
  connectedCallback() {
    document.addEventListener(
      "storefront:signincompleted",
      this.handleStorefrontSignInCompleted.bind(this),
    );
  }
  handleStorefrontSignInCompleted(event) {
    var _a, _b;
    if (
      (_a = event == null ? void 0 : event.detail) == null ? void 0 : _a.avatar
    ) {
      (_b = this.icon) == null
        ? void 0
        : _b.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}
defineElement("account-icon", AccountIcon);
class GlobalTooltip {
  constructor() {
    const mm = window.matchMedia("(hover: hover) and (pointer: fine)");
    this.currentTooltip = null;
    this.showTimeout = null;
    this.hideTimeout = null;
    if (mm.matches) {
      this.init();
    }
  }
  init() {
    this.setupEventDelegation();
  }
  setupEventDelegation() {
    document.addEventListener(
      "mouseenter",
      this.handleMouseEnter.bind(this),
      true,
    );
    document.addEventListener(
      "mouseleave",
      this.handleMouseLeave.bind(this),
      true,
    );
    document.addEventListener("focusin", this.handleFocusIn.bind(this), true);
    document.addEventListener("focusout", this.handleFocusOut.bind(this), true);
  }
  handleMouseEnter(event) {
    var _a;
    if (!((_a = event.target) == null ? void 0 : _a.closest)) return;
    const element = event.target.closest("[tooltip-text]");
    if (element) {
      this.showTooltip(element);
    }
  }
  handleMouseLeave(event) {
    var _a;
    if (!((_a = event.target) == null ? void 0 : _a.closest)) return;
    const element = event.target.closest("[tooltip-text]");
    if (element) {
      this.hideTooltip();
    }
  }
  handleFocusIn(event) {
    var _a;
    if (!((_a = event.target) == null ? void 0 : _a.closest)) return;
    const element = event.target.closest("[tooltip-text]");
    if (element) {
      this.showTooltip(element);
    }
  }
  handleFocusOut(event) {
    var _a;
    if (!((_a = event.target) == null ? void 0 : _a.closest)) return;
    const element = event.target.closest("[tooltip-text]");
    if (element) {
      this.hideTooltip();
    }
  }
  createTooltipElement(element) {
    const tooltipText = element.getAttribute("tooltip-text");
    const position = element.getAttribute("tooltip-position") || "bottom";
    const tooltipElement = document.createElement("div");
    tooltipElement.className = `tooltip tooltip--${position}`;
    tooltipElement.textContent = tooltipText;
    document.body.appendChild(tooltipElement);
    this.positionTooltip(tooltipElement, element, position);
    return tooltipElement;
  }
  positionTooltip(tooltipElement, targetElement, position) {
    const targetRect = targetElement.getBoundingClientRect();
    const tooltipRect = tooltipElement.getBoundingClientRect();
    const offset = 12;
    let top, left;
    switch (position) {
      case "top":
        top = targetRect.top - tooltipRect.height - offset;
        left = targetRect.left + (targetRect.width - tooltipRect.width) / 2;
        break;
      case "right":
        top = targetRect.top + (targetRect.height - tooltipRect.height) / 2;
        left = targetRect.right + offset;
        break;
      case "left":
        top = targetRect.top + (targetRect.height - tooltipRect.height) / 2;
        left = targetRect.left - tooltipRect.width - offset;
        break;
      case "bottom":
      default:
        top = targetRect.bottom + offset;
        left = targetRect.left + (targetRect.width - tooltipRect.width) / 2;
        break;
    }
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    if (left < offset) left = offset;
    if (left + tooltipRect.width > viewportWidth - offset) {
      left = viewportWidth - tooltipRect.width - offset;
    }
    if (top < offset) top = offset;
    if (top + tooltipRect.height > viewportHeight - offset) {
      top = viewportHeight - tooltipRect.height - offset;
    }
    tooltipElement.style.position = "fixed";
    tooltipElement.style.top = `${top}px`;
    tooltipElement.style.left = `${left}px`;
  }
  showTooltip(element) {
    if (element.hasAttribute("disabled")) return;
    const hasDisabledChild = element.querySelector("[disabled]");
    if (hasDisabledChild) return;
    const tooltipText = element.getAttribute("tooltip-text");
    if (!tooltipText) return;
    clearTimeout(this.hideTimeout);
    this.showTimeout = setTimeout(() => {
      if (this.currentTooltip) {
        this.currentTooltip.remove();
      }
      this.currentTooltip = this.createTooltipElement(element);
      requestAnimationFrame(() => {
        if (this.currentTooltip) {
          this.currentTooltip.classList.add("tooltip--visible");
        }
      });
    }, 200);
  }
  hideTooltip(immediate = false) {
    clearTimeout(this.showTimeout);
    const hideAction = () => {
      if (this.currentTooltip) {
        this.currentTooltip.remove();
        this.currentTooltip = null;
      }
    };
    if (immediate || !this.currentTooltip) {
      hideAction();
    } else {
      this.currentTooltip.classList.remove("tooltip--visible");
      this.hideTimeout = setTimeout(hideAction, 200);
    }
  }
}
document.addEventListener("DOMContentLoaded", () => {
  window.globalTooltip = new GlobalTooltip();
});
